import React, { useState } from "react";

const Page8 = () => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="moc-page">
      {/* ESQUERDA */}
      <div className="moc-left" style={{ paddingTop: '260px' }}>        
        <p>Até aqui, falamos sobre o que é uma mudança e como ela pode ser classificada no Gerenciamento de Mudanças. Mas como isso aparece, de fato, no dia a dia das operações?</p>
        <p>Na prática, as mudanças nem sempre são óbvias e podem surgir em atividades rotineiras ou ajustes operacionais.</p>
        <p>A seguir, exemplos de situações que podem caracterizar uma mudança.</p>
      </div>

      {/* DIREITA */}      
      <div className="moc-right" style={{ paddingTop: '160px' }}>
        <img src="./img/module1/page8.jpg" alt="" style={{ width: '80%' }} />
      </div>

      <style>{`

        .container{
          width: 100% !important;
        }

        /* ROOT DA PÁGINA */
        .moc-page {
          display: flex;
          height: 100%;
          overflow: hidden;
        }

        /* COLUNA DIREITA */
        .moc-right {
          width: 50%;
          background: #ffffff;
          padding: 30px;
          box-sizing: border-box;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        /* COLUNA ESQUERDA */
        .moc-left {
          width: 50%;
          padding-top: 250px;
          // background: #ffffff;
          color: #ffffff;
          padding: 40px;
          box-sizing: border-box;        }

        .moc-left p {
          white-space: pre-line;
          line-height: 1.6;
        }

        /* ================= MOBILE ================= */
        @media (max-width: 768px) {

          .moc-page {
            flex-direction: column;
            // height: auto;
          }

          .moc-left,
          .moc-right {
            width: 100%;
            padding: 20px;
          }

          .moc-left {
            padding-top: 100px !important;
          }

          .moc-right {
            padding-top: 0px !important;
          }

          .moc-right img {
            width: 100%;
            max-width: 300px;
          }

        }

      `}</style>
    </div>
  );
};

export default Page8;